module.exports = __webpack_public_path__ + "static/media/aboutus.c45616ec.jpg";